<template>
    <section class="performance-waybill-detail-wrapper" v-loading="bdLoading">
        <div class="detail-container">
        <div class="waybill-info-header">
                <i class="el-icon-back" @click="backToIndex"></i>
                <span class="info-header-content" @dblclick.self="dblclickCopy()">
                    <strong>运输单号:</strong>
                    {{ taskNo }}<i class="el-icon-document-copy" @click.stop="dblclickCopy()"></i>
                </span>
                <span class="info-header-content"><strong>运输单状态：</strong><span class="info-header-active">{{formData.taskStatus}}</span></span>
                <span><strong>创建人：</strong>{{formData.createUserName}}</span>
                <el-button class="button-update" @click="update" :loading="btnLoading">刷新</el-button>
            </div>
            <!-- 链路信息 -->
            <link-information :linkData="linkData" :dictData="dictData" :taskNo="taskNo" :componentsData="{ dispatchNo }"></link-information>
            <!-- 基础信息 -->
            <order-information :formData="formData"></order-information>
            <!-- 地址信息 -->
            <sender-information :formData="formData"></sender-information>
            <!-- 收货信息 -->
            <!-- <receiver-information :formData="formData"></receiver-information> -->
            <!-- 最终收货信息 -->
            <!-- <div class="information-wrapper content-wrapper">
                <el-collapse>
                    <el-collapse-item>
                        <template slot="title">
                            <div class="header-title">
                                <span class="header-title-block"></span>
                                <span class="header-title-txt">最终收货信息</span>
                            </div>
                        </template>
                        <final-information :formData="formData"></final-information>
                    </el-collapse-item>
                </el-collapse>
            </div> -->
            <!-- 时间信息 -->
            <time-information :formData="formData"></time-information>
            <!-- 费用信息 -->
            <div class="information-wrapper content-wrapper">
                <el-collapse v-model="activeName">
                    <el-collapse-item name="collection">
                        <template slot="title">
                            <div class="header-title">
                                <span class="header-title-block"></span>
                                <span class="header-title-txt">费用信息</span>
                            </div>
                        </template>
                        <collection-information :formData="formData" style="margin: 10px 0;"></collection-information>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <!-- 商品信息 -->
            <goods-information :formData="formData" :tableData="tableData"></goods-information>
        </div>
    </section>
</template>

<script>
import { queryWaybillDetail, queryWaybillDetailList, queryStatusRoute } from '@/modules/transport/otp/api/performanceWaybillManage';
import { dictWithUrl } from '@/components/lots/api.js';
import { copyToClip, formatData, formatLinkInfo, formatTableData } from './util.js';
import LinkInformation from './components/LinkInformation.vue';
import OrderInformation from './components/OrderInformation.vue';
import SenderInformation from './components/SenderInformation.vue';
// import ReceiverInformation from './components/ReceiverInformation.vue';
// import FinalInformation from './components/FinalInformation.vue';
import TimeInformation from './components/TimeInformation.vue';
import CollectionInformation from './components/CollectionInformation.vue';
import GoodsInformation from './components/GoodsInformation.vue';
export default {
    name: 'waybillDetail',
    components: {
        LinkInformation,
        OrderInformation,
        SenderInformation,
        TimeInformation,
        CollectionInformation,
        GoodsInformation
    },
    data () {
        return {
            bdLoading: false,
            btnLoading: false,
            activeName: 'collection',
            id: '',
            taskNo: '',
            dispatchNo: '',
            tableData: [],
            dictData: {}, // 数据字典集合
            formData: {}, // 表单数据
            linkData: {}
        };
    },
    mounted () {
        this.id = this.$route.query.id;
        this.taskNo = this.$route.query.taskNo;
        this.dispatchNo = this.$route.query.dispatchNo;
        this.id && this.taskNo && this.initPage(this.id, this.taskNo);
    },
    activated () {
        const { taskNo } = this.$route.query;
        if (taskNo !== this.taskNo) {
            this.id = this.$route.query.id;
            this.taskNo = this.$route.query.taskNo;
            this.dispatchNo = this.$route.query.dispatchNo;
            this.id && this.taskNo && this.initPage(this.id, this.taskNo);
        }
    },
    methods: {
        update() {
            this.initPage(this.id, this.taskNo);
        },
        /**
         * @description 初始化界面
         * @param {string} id 运输单ID
         * @returns {Object} 运输单详情
         */
        async initPage (id, taskNo) {
            this.bdLoading = true;
            const _that = this;
            await this.getDicData();
            Promise.all([_that.getWaybillDetail(id), _that.getWaybillDetailList(taskNo), _that.queryStatusRoute(id)])
                .then(res => {
                    this.formData = formatData({
                        ...res[0].data.baseReturnOrderDto,
                        ...res[0].data
                    }, this.dictData);
                    this.tableData = formatTableData(res[1].data);
                    this.linkData = formatLinkInfo(res[2].data);
                })
                .catch(() => { })
                .finally(() => {
                    this.bdLoading = false;
                });
        },
        dblclickCopy () {
            copyToClip(this.taskNo);
        },
        getWaybillDetail (id) {
            return queryWaybillDetail({ id: id });
        },
        getWaybillDetailList (taskNo) {
            return queryWaybillDetailList(taskNo);
        },
        backToIndex () {
            this.$router.push({
                path: `/performance/waybill-manage`
            });
        },
        /**
         * @description 查询链路信息
         */
        queryStatusRoute (id) {
            return queryStatusRoute(id);
        },
        /**
         * @description 获取数据字典:
         * 订单类型: ORDER_TYPE
         * 任务类型: TASK_TYPE
         * 业务模式: BUSINESS_MODE
         * 配送类型：DELIVERY_TYPE
         * 是否分拨： DISTRIBUTION_FLAG
         * 是否最后一次分拨: DISTRIBUTION_LAST_FLAG
         * 来源系统: SOURCE_SYSTEM
         * 业务大类：BUSINESS_CATEGORY
         * 签收类型：DELIVERED_VERIFY_FLAG
         * 代收货款方式：TMS_COLLECTION_MODE
         * 快消订单标识：IS_FAST_SELL
         * 客户时效类型：CUSTOMER_AGING_TYPE
         * @param {string} 数据字典编码字符串
         * @return {Object} 数据字典类型集合
         *
         */
        async getDicData () {
            /* eslint-disable max-len */
            const dict = await dictWithUrl(
                'ORDER_TYPE,TASK_TYPE,BUSINESS_MODE,DELIVERY_TYPE,DISTRIBUTION_FLAG,DISTRIBUTION_LAST_FLAG,SOURCE_SYSTEM,BUSINESS_CATEGORY,SIGN_TYPE,TMS_COLLECTION_MODE,IS_FAST_SELL,DELIVERED_VERIFY_FLAG,CUSTOMER_AGING_TYPE,BUSINESS_TYPE,TRANSPORT_STATUS,IN_OUT_TYPE,TRANSPORT_TYPE,SYS_PROFESSIONAL_COMPANY,WMS_STATUS,TMS_SHIPPING_TYPE,OTP_EMERGENCE_FLAG,PROJECT_CLASSIFY,DELIVERYPAY_TYPE,OMS_BUYER_TYPE,TRANSFER_TYPE_TMS,OMS_PARAMS_ENTITY_ID,ORDER_SOURCE_PLATFORM,ORDER_SERVICE_TYPE,TMS_VIP_FLAG,TMS_OPERATION_NODE,OPERATION_LOG_ATTACHMENT_TYPE'
            );
            this.dictData = dict.data;
        }
    }
};
</script>

<style lang="less">
@import './waybillDetail.less';
</style>
